import { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Layout-level route guard.
 * Wraps the AppLayout and redirects to /login if not authenticated.
 */
export function ProtectedRoute() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  const location = useLocation();
  const [showWarning] = useState(false);
  const requestedPath =
    location.pathname === '/'
      ? `/dashboard${location.search}${location.hash}`
      : `${location.pathname}${location.search}${location.hash}`;
  const loginUrl = `/login?${new URLSearchParams({ returnTo: requestedPath }).toString()}`;

  if (!isAuthenticated) {
    return <Navigate to={loginUrl} state={{ from: requestedPath }} replace />;
  }

  return (
    <>
      {showWarning && (
        <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white text-center py-2 text-sm font-medium shadow-lg">
          Your session will expire soon due to inactivity. Move the mouse or press a key to stay
          signed in.
        </div>
      )}
      <Outlet />
    </>
  );
}
